import { apiSlice } from 'api/api'
import { configureStore } from '@reduxjs/toolkit'
import userPreferences from './userPreferences'
const store = configureStore({
  reducer: {
    userPreferences,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
})

export default store
